import React, { useEffect, useState } from "react";
import TableWrapper from "../../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import useProductVariantColumn from "../Hook/useProductVariantColumns";
import { useSelector } from "react-redux";
import { getProductAttributes } from "../OrderService";
import ProductAttributesModal from "../Modal/ProductAttributesModal";
import { Button, Col, Row } from "react-bootstrap";
import { formatAmount } from "../../../../Utils/CommonUtils";
import ProductAttributeModalEdit from "../Modal/ProductAttributeModalEdit";

const ProductVariant = ({
  nextLabel,
  onDownloadQuote,
  onSendQuote,
  onSaveQuote,
  resetOnClose,
  openAttributesSignal,
  // Only the attributes modal (e.g. Re-Quote from the quote's Quotes tab)
  modalOnly,
  // Premium line and Attributes button on one row, as on the quote screen
  inlineHeader,
  // On the quote screen: the modal must not read the route id as an order
  isQuote,
  // Runs before the Attributes button opens the modal (a saved quote reloads
  // its variant_json with getQuote); may return a promise
  onBeforeOpenAttributes,
  // e.g. a quote already converted to an order
  attributesDisabled,
}) => {
  const productAttributeData = useSelector(
    (state) => state.order.productAttributeData
  );
  const variant = useSelector(
    (state) => state.order.selectedOrders.productVariant
  );
  const formState = useSelector((state) => state.common.formRendererState);
  const productVariantModalState = useSelector(
    (state) => state.order.productVariantModalState
  );
  // Modal state management
  const [showModal, setShowModal] = useState(false);
  const [selectedProductEntityId, setSelectedProductEntityId] = useState(null);

  // Function to close the modal
  const handleClose = () => {
    setShowModal(false);
    setSelectedProductEntityId(null);
  };

  const handleProductModal = (entityId) => {
    setSelectedProductEntityId(entityId);
    setShowModal(true); // Show the modal
  };

  const { productVariant } = useProductVariantColumn();

  // Opened from outside (e.g. Re-Quote): each change of the signal opens the modal
  useEffect(() => {
    if (openAttributesSignal) {
      setShowModal(true);
    }
  }, [openAttributesSignal]);

  useEffect(() => {
    if (formState.product_id) {
      getProductAttributes(formState.product_id);
    }
  }, [formState.product_id]);

  // Function to handle clicking the "Attributes" button
  const handleAttributesButtonClick = (entityId) => {
    if (!onBeforeOpenAttributes) {
      handleProductModal(entityId); // Show the modal with the selected entity ID
      return;
    }
    Promise.resolve(onBeforeOpenAttributes()).finally(() =>
      handleProductModal(entityId)
    );
  };

  return (
    <div>
      {!modalOnly && (
        <>
          {inlineHeader ? (
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="amount-wrapper mb-0">
                Total Premium Amount
                {productVariantModalState?.finalPremium
                  ? ` - ${formatAmount(
                      productVariantModalState.finalPremium,
                      null,
                      null,
                      "lakh"
                    )}`
                  : ""}
              </div>
              <Button
                disabled={attributesDisabled}
                onClick={() =>
                  handleAttributesButtonClick(selectedProductEntityId)
                }
              >
                Attributes
              </Button>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3">
                <Button
                  className="flex-end"
                  onClick={() =>
                    handleAttributesButtonClick(selectedProductEntityId)
                  }
                >
                  Attributes
                </Button>
              </div>
              <Row className="amount-wrapper">
                <Col xs="12">
                  Total Premium Amount -{" "}
                  {productVariantModalState?.finalPremium
                    ? formatAmount(
                        productVariantModalState.finalPremium,
                        null,
                        null,
                        "lakh"
                      )
                    : "NA"}
                </Col>
                {/* <Col xs="3">
                  Cover Amount -{" "}
                  {productVariantModalState?.coverAmount
                    ? formatAmount(
                        productVariantModalState.coverAmount,
                        null,
                        null,
                        "lakh"
                      )
                    : "NA"}
                </Col> */}
              </Row>
            </>
          )}
          <TableWrapper
            columns={productVariant}
            data={productAttributeData}
            hidePagination
            hideTabsWrapper={true}
          />
        </>
      )}
      <ProductAttributeModalEdit
        show={showModal}
        onHide={handleClose}
        selectedProductEntityId={selectedProductEntityId}
        nextLabel={nextLabel}
        resetOnClose={resetOnClose}
        isQuote={isQuote}
        onSaveQuote={onSaveQuote}
        onDownloadQuote={onDownloadQuote}
        onSendQuote={
          onSendQuote
            ? () => {
                // Close the attributes modal so Send Quote opens on its own
                handleClose();
                onSendQuote();
              }
            : undefined
        }
      />
    </div>
  );
};

export default ProductVariant;

// import React, { useEffect, useState } from "react";
// import TableWrapper from "../../../../Components/Common/Tables/Tanstack/components/TableWrapper";
// import useProductVariantColumn from "../Hook/useProductVariantColumns";
// import { useSelector } from "react-redux";
// import { getProductAttributes } from "../OrderService";
// import ProductAttributesModal from "../Modal/ProductAttributesModal";
// import { Button, Col, Row } from "react-bootstrap";
// import { formatAmount } from "../../../../Utils/CommonUtils";
// import ProductAttributeModalEdit from "../Modal/ProductAttributeModalEdit";
// import { changeLanguage } from "i18next";

// const ProductVariant = () => {
//   const productAttributeData = useSelector(
//     (state) => state.order.productAttributeData
//   );
//   const productAttributesList = productAttributeData?.flatMap(
//     (product) => product.product_attributes_list || []
//   );

//   const variant = useSelector(
//     (state) => state.order.selectedOrders.productVariant
//   );
//   const formState = useSelector((state) => state.common.formRendererState);
//   const productVariantModalState = useSelector(
//     (state) => state.order.productVariantModalState
//   );
//   // Modal state management
//   const [showModal, setShowModal] = useState(false);
//   const [selectedProductEntityId, setSelectedProductEntityId] = useState(null);

//   console.log("productAttributeData", variant);

//   // Function to close the modal
//   const handleClose = () => {
//     setShowModal(false);
//     setSelectedProductEntityId(null);
//   };

//   const handleProductModal = (entityId) => {
//     setSelectedProductEntityId(entityId);
//     setShowModal(true); // Show the modal
//   };

//   const { productVariant } = useProductVariantColumn();

//   useEffect(() => {
//     if (formState.product_id) {
//       getProductAttributes(formState.product_id);
//     }
//   }, [formState.product_id]);

//   // Function to handle clicking the "Attributes" button
//   const handleAttributesButtonClick = (entityId) => {
//     handleProductModal(entityId); // Show the modal with the selected entity ID
//   };

//   console.log("productVariantModalState", productVariantModalState);

//   return (
//     <div>
//       <div className="d-flex justify-content-end mb-3">
//         <Button
//           className="flex-end"
//           onClick={() => handleAttributesButtonClick(selectedProductEntityId)}
//         >
//           Attributes
//         </Button>
//       </div>
//       <Row className="amount-wrapper">
//         <Col xs="3">
//           Total Premium Amount -{" "}
//           {productVariantModalState?.finalPremium
//             ? formatAmount(
//                 productVariantModalState.finalPremium,
//                 null,
//                 null,
//                 "lakh"
//               )
//             : "NA"}
//         </Col>
//         {/* <Col xs="3">
//           Cover Amount -{" "}
//           {productVariantModalState?.coverAmount
//             ? formatAmount(
//                 productVariantModalState.coverAmount,
//                 null,
//                 null,
//                 "lakh"
//               )
//             : "NA"}
//         </Col> */}
//       </Row>
//       <div className="product-variant-attributes">
//         {productAttributeData.length > 0 ? (
//           <table className="product-table">
//             <thead>
//               <tr>
//                 <th>Name</th>
//                 <th>Category</th>
//                 <th>Cover Amount</th>
//               </tr>
//             </thead>
//             <tbody>
//               {productAttributeData.map((product, index) => {
//                 const coverAmount =
//                   productVariantModalState?.variant?.[String(product.entityid)]
//                     ?.cover || "-";

//                 return (
//                   <tr key={index}>
//                     <td>{product.name || "-"}</td>
//                     <td>{product.product_category || "-"}</td>
//                     <td>
//                       {coverAmount
//                         ? formatAmount(coverAmount, null, null, "lakh")
//                         : "NA"}
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         ) : (
//           <p>No product attributes found.</p>
//         )}
//       </div>

//       {/* )} */}
//       <ProductAttributeModalEdit
//         show={showModal}
//         onHide={handleClose}
//         selectedProductEntityId={selectedProductEntityId}
//       />
//     </div>
//   );
// };

// export default ProductVariant;
